var map = {
	"./theme_gold/images/Withdraw-gold.svg": "171d",
	"./theme_gold/images/Withdraw-icon.svg": "4d29",
	"./theme_gold/images/add.svg": "00f8",
	"./theme_gold/images/bankB-gold.svg": "a442",
	"./theme_gold/images/bankB-icon.svg": "1023",
	"./theme_gold/images/bitcoin-btc-gold.svg": "2ece",
	"./theme_gold/images/bitcoin-btc-logo.svg": "e7ed",
	"./theme_gold/images/bullhorn.svg": "1497",
	"./theme_gold/images/cach-gold.svg": "3d0e",
	"./theme_gold/images/cach-icon.svg": "70a4",
	"./theme_gold/images/card-gold.svg": "7597",
	"./theme_gold/images/card-icon.svg": "a316",
	"./theme_gold/images/comments-question.svg": "a918",
	"./theme_gold/images/crypto-ada.svg": "f014",
	"./theme_gold/images/crypto-bch.svg": "604f",
	"./theme_gold/images/crypto-bnb.svg": "ea95",
	"./theme_gold/images/crypto-btc.svg": "8555",
	"./theme_gold/images/crypto-dai.svg": "f1cc",
	"./theme_gold/images/crypto-doge.svg": "a829",
	"./theme_gold/images/crypto-eos.svg": "3f53",
	"./theme_gold/images/crypto-eth.svg": "0ecc",
	"./theme_gold/images/crypto-jpy.svg": "c760",
	"./theme_gold/images/crypto-ltc.svg": "3739",
	"./theme_gold/images/crypto-shib.svg": "9d9c",
	"./theme_gold/images/crypto-teth.svg": "d07c",
	"./theme_gold/images/crypto-trx.svg": "8e2c",
	"./theme_gold/images/crypto-usdc.svg": "a711",
	"./theme_gold/images/crypto-usdt.svg": "6fb5",
	"./theme_gold/images/crypto-xrp.svg": "5d3f",
	"./theme_gold/images/default-crypto.svg": "16ef",
	"./theme_gold/images/deposit-gold.svg": "60aa",
	"./theme_gold/images/deposit-icon.svg": "3c1b",
	"./theme_gold/images/dot-dk.svg": "94d4",
	"./theme_gold/images/dot-orange.svg": "ada5",
	"./theme_gold/images/dot.svg": "4f38",
	"./theme_gold/images/electron-gold.svg": "f8a1",
	"./theme_gold/images/electron-icon.svg": "082a",
	"./theme_gold/images/email.svg": "b4d8",
	"./theme_gold/images/heart-line.svg": "343e",
	"./theme_gold/images/heart.svg": "5fe9",
	"./theme_gold/images/icon-top-arrow.svg": "f7c8",
	"./theme_gold/images/icon_jpy.svg": "cd57",
	"./theme_gold/images/icon_uestion.svg": "4731",
	"./theme_gold/images/icon_usd.svg": "fbc8",
	"./theme_gold/images/jp-yen.svg": "19ca",
	"./theme_gold/images/monyback-gold.svg": "63c5",
	"./theme_gold/images/monyback-icon.svg": "1513",
	"./theme_gold/images/no.svg": "ef64",
	"./theme_gold/images/structure01.svg": "e843",
	"./theme_gold/images/structure02.svg": "ccfc",
	"./theme_gold/images/structure03.svg": "767f",
	"./theme_gold/images/trophy-gold.svg": "6d69",
	"./theme_gold/images/trophy-icon.svg": "257d",
	"./theme_gold/images/vector.svg": "e980"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";